/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PeriodoEsenzioneTariffaDTO { 
    mese_inizio?: string;
    mese_fine?: string;
}

